const defaultTitle = 'Lorem ipsum'
const defaultContent = 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer cursus ex non ex malesuada ' +
  'interdum. Fusce luctus arcu est, non vehicula ex semper ac. Pellentesque eget quam nisl. In lacinia diam mattis, ' +
  'tristique enim id, porta nibh. Suspendisse at felis dolor. Mauris eu imperdiet magna.'

export default {
  name: 'collapsable',
  data () {
    return {
      naturalHeight: 0, // Calculated when mounted.
      active: false,
      loaded: false
    }
  },
  props: {
    title: {
      type: String,
      default: defaultTitle
    },
    content: {
      type: String,
      default: defaultContent
    }
  },
  mounted () {
    // Find out the height to allow transitioning to it.
    this.active = true
    this.naturalHeight = this.$el.querySelector('p').offsetHeight
    this.active = false
    this.loaded = true
  }
}



// WEBPACK FOOTER //
// ./src/components/collapsable/script.js